import { render, staticRenderFns } from "./ColorCategories.vue?vue&type=template&id=3d513a02&"
import script from "./ColorCategories.vue?vue&type=script&lang=js&"
export * from "./ColorCategories.vue?vue&type=script&lang=js&"
import style0 from "./ColorCategories.vue?vue&type=style&index=0&id=3d513a02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports